namespace C2S {

    @C2S.Decorators.registerInterface()
    export class IGetEditValue {
    }

    export interface IGetEditValue {
        getEditValue(property: PropertyItem, target: any): void;
    }
}